<template>
    <div>
        <ShareInvoiceModal :show_share_invoice.sync="modals.show_share_invoice" />  
        <el-drawer :modal="false" 
        :visible.sync="drawerEditProFormaInvoice"
        class="drawer-edit-invoice drawer-invoice-table"
        size="45%"
        >
            <template slot="title">
                <div class="d-flex justify-content-between align-items-center">
                    <h3 class="font-weight-600">Edit Invoice</h3>
                    <div class="d-flex align-items-center mx-2">
                        <!-- <div class="d-flex align-items-center mx-2 text-primary cursor-pointer" @click="$refs.preview_modal.preview('https://api_gw_demo.imortgage2u.com/billing/invoice/generate-pdf/1')">
                            Eye icon
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="currentColor" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
                            <p class="text-xs mx-1 text-primary">Preview</p>
                        </div> -->
                        <div class="d-flex align-items-center mx-2 text-primary cursor-pointer" @click="generatePdf(invoiceForm.inv_id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="currentColor" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
                            <p class="text-xs mx-1 text-primary">Preview</p>
                        </div>
                        <div class="d-flex align-items-center text-primary cursor-pointer" @click="modals.show_share_invoice = true">
                            <!-- share icon -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304c0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.9-22.2-26.4-22.2-56.8 0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144a31.76 31.76 0 0 0-34.4-5.4z"/></svg>
                            <p class="text-xs mx-1 text-primary">Share</p>
                        </div>
                    </div>
                </div>
            </template>

            <b-container>
                <div class="mb-3 d-flex justify-content-between">
                    <div>
                        <p class="bottom-line">Invoice No: {{ invoiceForm.inv_ref_no ? invoiceForm.inv_ref_no : '-' }}</p>
                    </div>
                    <div>
                        <p class="bottom-line">Issued Date: {{ invoiceForm.inv_issued_date | dateFormatString }}</p>
                    </div>
                </div>
                <div class="d-flex justify-content-between mb-0">
                    <div>
                        <h3>Customer Detail</h3>
                        <p class="text-primary">{{ invoiceForm.inv_user_name }} </p>
                        <p>{{ invoiceForm.inv_user_email != 0 ? invoiceForm.inv_user_email : 'N/A' }} </p>
                        <p>{{ invoiceForm.inv_user_mobile != 0 ? invoiceForm.inv_user_mobile : 'N/A' }} </p>
                    </div>
                </div>

                <hr class="hr">

                <h3>Product Details</h3>

                <div class="table-listings input-table">
                    <b-table-simple bordered class="table-listings input-table">
                        <b-thead>
                            <b-tr style="border: #252938;">
                                <b-th width="35%" style="background-color: #252938;" class="text-white">Product Name</b-th>
                                <b-th style="min-width: 70%; background-color: #252938;" class="text-white">Description</b-th>
                                <b-th width="25%" style="background-color: #252938;" class="text-white">Amount (RM)</b-th>
                                <b-th style="background-color: #252938;"></b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-td class="p-0 m-0">
                                    <el-input 
                                        placeholder="Product Name"
                                        class="input-table"
                                        v-model="items.item_name"
                                    ></el-input>
                                </b-td>
                                <b-td class="p-0 m-0">
                                    <el-input 
                                        placeholder="Description"
                                        class="input-table"
                                        v-model="items.item_description"
                                    ></el-input>
                                </b-td>
                                <b-td class="p-0 m-0">
                                    <CurrencyInput
                                        :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                        class="border-0"
                                        v-model="items.item_amount"
                                    />
                                </b-td>
                                <b-td>
                                    <el-button class="m-0 p-0" @click="addRowItem" :disabled="(items.item_description === '' || items.item_name === '')">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path fill="#28A745" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/></svg>
                                    </el-button>
                                </b-td>
                            </b-tr>
                            <b-tr v-for="item in invoiceForm.inv_items" :key="item.itm_id">
                                <b-td class="m-0">
                                    <p style="font-size: 13px;">{{ item.itm_tittle }}</p>
                                </b-td>
                                <b-td class="p-0 m-0">
                                    <el-input
                                        class="input-table"
                                        placeholder="Description"
                                        v-model="item.itm_description"
                                        >
                                    </el-input>
                                </b-td>
                                <b-td class="p-0 m-0">
                                    <CurrencyInput
                                        :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                        class="border-0"
                                        v-model="item.itm_total"
                                    />
                                </b-td>
                                <b-td>
                                    <el-button class="m-0 p-0" @click="removeRowItem(item)">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path fill="#DC3545" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"/></svg>
                                    </el-button>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td colspan="2" style="border: none;" class="text-right font-weight-700">SubTotal</b-td>
                                <b-td class="font-weight-700">RM {{ currTotalAmount | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr> 
                                <b-td colspan="2" class="text-right">Tax</b-td>
                                <b-td>RM {{ invoiceForm.inv_tax_amount | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr> 
                                <b-td colspan="2" style="font-size: 16px;" class="text-right font-weight-600">Total</b-td>
                                <b-td style="font-size: 16px;" class="font-weight-600">RM {{ currTotalAmount | moneyFormatter }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>

                <b-form-group
                    label="Remarks"
                    class="my-2"
                >
                    <el-input
                        type="textarea"
                        rows="4"
                        v-model="invoiceForm.inv_remark">
                    </el-input>
                </b-form-group>

                <b-row class="mt-1 pt-4 pb-5 text-center w-100">
                    <b-col cols="4">

                    </b-col>
                    <b-col cols="4">
                        <b-button variant="primary" type="submit" class="w-100" @click="submit()" :disabled="checkItems">Update</b-button>
                    </b-col>
                </b-row>
                <PreviewModal ref="preview_modal"></PreviewModal>
            </b-container>
        </el-drawer>
    </div>
</template>
<style>
#consentFormDropzone.dropzone .dz-preview .dz-progress {
  display: none !important
}
</style>
<script>
    import { Drawer, Button, Select, Option, DatePicker, Table, TableColumn } from 'element-ui'
    import vue2Dropzone, { methods } from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import {axios, services, getHeader, helperFunctionMixin } from '@/assets/js/httpImports.js'
    import { mapState, mapActions } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import CurrencyInput from '@/components/CurrencyInput'
    import ShareInvoiceModal from '@/views/Sales/ProFormaInvoices/Modals/ShareInvoiceModal.vue'
    import PreviewModal  from '@/components/Modal/PreviewModal'

    export default {
        components: {
            vueDropzone: vue2Dropzone,
            CurrencyInput,
            ShareInvoiceModal,
            PreviewModal,
            [Drawer.name]: Drawer,
            [Button.name]: Button,
            [Select.name]: Select,
            [Option.name]: Option,
            [DatePicker.name]: DatePicker,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        mixins: [notifyFunctionMixin, helperFunctionMixin],
        data() {
            return {
                drawerEditProFormaInvoice: false,
                tableData: [],
                invoiceForm: {
                    inv_user_id: this.inv_user_id,
                    inv_user_type:"customer",
                    inv_user_name:"Tan Lee Lee",
                    inv_stm_id:null, //if set will check existing
                    inv_scrb_id:1, //if set will check existing
                    inv_pckg_id:null, //if set will check existing
                    inv_title:"Trial Test",
                    inv_description:null,
                    inv_ref_no:null, //if null will auto generate
                    inv_issued_date:"",
                    inv_status:"ISSUED", //DRAFT,ISSUED,PAID,CANCELED
                    inv_remark:null,
                    inv_tax_amount: 0.00,
                    inv_items: [
                    ],
                },
                items: {
                    item_id:0,
                    item_name: "",
                    item_description: "",
                    item_amount: "",
                },
                modals: {
                    show_share_invoice: false
                },
            }
        },
        computed:{
            currTotalAmount() {
                return this.invoiceForm.inv_items.reduce((total, row) => total + Number(row.itm_amount), 0);
            },
            checkItems() {
                if(this.invoiceForm.inv_items.length > 0){
                    return false
                }
                return true
            }
        },
        methods: {
            viewEditProformaInvoice(data) {
                this.invoiceForm = data
                this.drawerEditProFormaInvoice = !this.drawerEditProFormaInvoice
            },

            submit() {
                let formData = this.invoiceForm
                axios.post(services.billing + 'invoice/' + formData.inv_id, formData, { headers: getHeader() })
                    .then(res => {
                        this.resetFormToNull(this.invoiceForm)
                        this.invoiceForm.inv_items = []
                        this.notifySuccess('<b>Invoice : ' + res.data.inv_ref_no + '</b> - Successfully Updated.')
                        this.drawerEditProFormaInvoice = !this.drawerEditProFormaInvoice
                        this.$emit('getInvoice')
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },

            addRowItem() {
                this.items.item_id += 1
                this.invoiceForm.inv_items.push({
                    row_no: this.items.item_id,
                    itm_tittle: this.items.item_name,
                    itm_description: this.items.item_description,
                    itm_qty: 1,
                    itm_qty: 1,
                    itm_amount: this.items.item_amount,
                    itm_total: this.items.item_amount
                })
                this.items.item_name = ''
                this.items.item_description = ''
                this.items.item_amount = ''
            },

            removeRowItem(data) {
                if(data.itm_id) {
                    this.invoiceForm.inv_items = this.invoiceForm.inv_items.filter(item => item.itm_id !== data.itm_id)
                }
                else{
                    this.invoiceForm.inv_items = this.invoiceForm.inv_items.filter(item => item.row_no !== data.row_no)
                }
            },

            generatePdf(inv_id) {
                axios.post(services.billing + 'invoice/generate-pdf/' + inv_id, {}, { headers: getHeader() })
                    .then(res => {
                        this.$refs.preview_modal.preview(res.data.url)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            }
        }
    }
</script>
